import React from 'react';

// Código do serviço, SEMPRE, e o rótulo do usuário ao lado quando existe.
//
// Compartilhado porque são dois os lugares que listam serviços — o quadro de
// Serviços e o Financeiro — e nos dois é pelo código que se fala de um deles.
//
// Antes o rótulo escondia o código, e o código sozinho vinha em cinza claro:
// na listagem ele sumia justamente quando alguém precisava dizer "o 2026-0042".
// O código é o que se fala e o que se busca; o rótulo é o apelido.
//
// O número aparece INTEIRO. O `.slice(-6)` daqui vinha de quando o código era
// um `2026-08-18-a1b2` sem gerador e longo demais para caber; agora é
// `2026-0042`, e cortar as pontas destruía justamente o que serve para uma
// pessoa dizer "a OPU do 2026-0042 abastece este".
const ServiceLabel = ({ service }) => {
  if (!service.service_code && !service.service_label) return null;
  return (
    <span className="inline-flex flex-wrap items-center gap-1 mt-0.5">
      {service.service_code && (
        <span className="text-xs font-mono font-semibold text-slate-700">
          #{service.service_code}
        </span>
      )}
      {service.service_label && (
        <span className="text-xs font-medium bg-slate-100 text-slate-700 rounded px-1.5 py-0.5">
          {service.service_label}
        </span>
      )}
    </span>
  );
};

export default ServiceLabel;
